module.exports = __webpack_public_path__ + "static/media/Img_9.d0738b99.jpg";